import React, { Component, Fragment } from 'react';
import { Filter, Main } from 'Containers';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { diff } from 'deep-diff';
import { CUSTOM_QUERY_FORM_NAME } from 'Common/FormEnum';
import { CustomQueryEnum } from 'Common/FieldEnum';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import * as actions from '../../../state/customQueries/action';
import { CustomQueryListForm } from './CustomQueryListForm';
import { submitForm } from 'State/forms/actions';
import { UtilitesConstants } from '../../../helper/constants';
import { createToast, toastType, errorToast } from 'Common/ToastHelper';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import 'Styles/pages/utilities/customqueries/index.less';
import {
  NewEditCategoryEnum,
  NewEditQueryEnum,
  SourceQueryEnum,
} from 'Common/Constants/Enumeration/CustomQueryEnum';
import { getIsDirty } from 'Common/Selectors/DirtySelector';

import { ReactTableWrapperColumnProperties } from 'Common/Constants';

class CustomQueryListFormContainer extends Component {
  static path = '/customqueries';
  state = {
    isQueryEdit: false,
    query: '',
    description: '',
    queryId: '',
    selected: '',
    isStandardQuery: false,
    selectedCategoryDescription: '',
    selectedCategoryId: 1,
    isAddNewCategory: false,
    isEditCategory: false,
    showQueryDeleteModel: false,
    showCategoryDeleteModel: false,
    selectedQueryId: '',
    columns: [
      {
        Header: 'DESCRIPTION',
        accessor: CustomQueryEnum.Description,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'CATEGORY',
        accessor: CustomQueryEnum.CategoryName,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'SOURCE',
        accessor: CustomQueryEnum.Source,
        ...ReactTableWrapperColumnProperties,
      },
      {
        resizable: false,
        width: 50,
        sortable: false,
        Cell: gridProps => {
          return GridContextMenu({
            gridProps,
            options: this.getMenuOptions(),
          });
        },
      },
    ],
  };

  getMenuOptions = () => {
    const menuOptions = [
      {
        icon: 'remove',
        text: 'Remove',
        handler: this.onRemoveQueryClick,
      },
      {
        icon: 'download',
        text: 'Download',
        handler: this.onDownloadClick,
      },
    ];
    return menuOptions;
  };

  componentDidMount() {
    this.props.getQueryCategoryList().then(result => {
      this.getSelectedCategoryName();
    });
    this.props.getCustomQueryData(this.state.selectedCategoryId);
  }

  componentDidUpdate(prevProps) {
    const {
      customQueryCategoryListData,
      newCategory,
      setQueryCategory,
    } = this.props;

    if (
      errorToast(this.props, prevProps, 'customQueryCategoryListError') ||
      errorToast(this.props, prevProps, 'customQueryDataError') ||
      errorToast(this.props, prevProps, 'categorySaveError') ||
      errorToast(this.props, prevProps, 'categoryEditError') ||
      errorToast(this.props, prevProps, 'categoryDeleteError') ||
      errorToast(this.props, prevProps, 'customQueryDownloadError') ||
      errorToast(this.props, prevProps, 'customQueryDeleteError') ||
      errorToast(this.props, prevProps, 'querySaveError') ||
      this.handleExecuteQueryError(this.props, prevProps)
    ) {
      this.props.clearQueryError();
    }

    if (this.props.categoryDeleteSuccess && !prevProps.categoryDeleteSuccess) {
      createToast(
        toastType.success,
        'Success',
        'Category has been removed!',
        true
      );
      this.props.clearQueryError();
    }
    if (
      customQueryCategoryListData.length >
        prevProps.customQueryCategoryListData.length &&
      newCategory
    ) {
      const newCategoryItem = customQueryCategoryListData.find(categoryItem => {
        return (
          categoryItem.Description.toUpperCase() ===
          newCategory.Description.toUpperCase()
        );
      });
      if (newCategoryItem && newCategoryItem.Id) {
        setQueryCategory(newCategoryItem.Id);
      }
      this.setState(
        {
          selectedCategoryId: newCategoryItem.Id,
          query: '',
          description: '',
          selected: '',
          isStandardQuery: false,
        },
        () => this.getFilterData()
      );
      this.resetAllFields();
    }

    if (this.props.categorySaveSuccess && !prevProps.categorySaveSuccess) {
      createToast(
        toastType.success,
        'Success',
        'Category has been saved!',
        true
      );
      this.props.clearQueryError();
    }
    if (
      this.props.customQueryDeleteSuccess &&
      !prevProps.customQueryDeleteSuccess
    ) {
      createToast(
        toastType.success,
        'Success',
        'Query has been deleted!',
        true
      );
      this.props.clearQueryError();
    }
    if (
      this.props.customQueryCategoryDeleteSuccess &&
      !prevProps.customQueryCategoryDeleteSuccess
    ) {
      createToast(
        toastType.success,
        'Success',
        'Category has been removed!',
        true
      );
      this.props.clearQueryError();
    }
    if (
      this.props.customQuerySaveSuccess &&
      !prevProps.customQuerySaveSuccess
    ) {
      createToast(toastType.success, 'Success', 'Query has been saved!', true);
      this.props.clearQueryError();
    }
  }

  handleExecuteQueryError = (props, prevProps) => {
    const { queryExecuteError } = props;

    if (
      queryExecuteError &&
      diff(queryExecuteError, prevProps.queryExecuteError)
    ) {
      if (
        !Array.isArray(queryExecuteError) &&
        queryExecuteError.Message === UtilitesConstants.CustomQuery.NoData
      ) {
        createToast(toastType.info, 'Results', queryExecuteError.Message, true);
        return true;
      } else {
        return errorToast(this.props, prevProps, 'queryExecuteError');
      }
    }
  };

  componentWillUnmount() {
    toast.dismiss();
  }
  getMainProps = () => {
    const { isAddNewCategory, isEditCategory, isStandardQuery } = this.state;
    const { query, description } = this.props;
    return {
      toolbox: {
        rightButtons: [
          {
            content: 'Save',
            onClick: this.onSaveQueryClick,
            disabled:
              isAddNewCategory ||
              isEditCategory ||
              !query ||
              !description ||
              isStandardQuery,
          },
          {
            content: 'Execute',
            onClick: this.onExecuteQueryClick,
            disabled:
              isAddNewCategory || isEditCategory || !query || !description,
          },
        ],
        shown: true,
      },
    };
  };

  setSelectedQueryCategory = (
    event,
    selectedCategoryId,
    prevSelectedCategoryId
  ) => {
    if (selectedCategoryId !== prevSelectedCategoryId) {
      this.setState(
        {
          selectedCategoryId: selectedCategoryId,
          query: '',
          description: '',
          selected: '',
          isStandardQuery: false,
        },
        () => this.getFilterData()
      );
      const { customQueryCategoryListData } = this.props;
      customQueryCategoryListData.filter(categoryItem => {
        if (categoryItem.Id === selectedCategoryId) {
          this.setState({
            selectedCategoryDescription: categoryItem.Description,
          });
        }
        return null;
      });
    }
  };

  getSelectedCategoryName = () => {
    const { selectedCategoryId } = this.state;
    const { customQueryCategoryListData } = this.props;
    customQueryCategoryListData.filter(categoryItem => {
      if (categoryItem.Id === selectedCategoryId) {
        this.setState({
          selectedCategoryDescription: categoryItem.Description,
        });
      }
      return null;
    });
  };

  getFilterData = () => {
    const { queryCategory } = this.props;
    this.props.getCustomQueryData(queryCategory);
  };

  onSaveQueryClick = () => {
    this.props.submitForm(CUSTOM_QUERY_FORM_NAME);
  };

  addNewQueryCategory = () => {
    this.setState({
      isAddNewCategory: true,
      isEditCategory: false,
    });
  };

  editSelectedQueryCategory = () => {
    const { selectedCategoryDescription } = this.state;
    this.setState({
      isEditCategory: true,
      isAddNewCategory: false,
    });
    this.props.setCategoryOnEdit(selectedCategoryDescription);
  };

  removeSelectedQueryCategory = () => {
    this.setState({
      isEditCategory: false,
      isAddNewCategory: false,
      showCategoryDeleteModel: !this.state.showCategoryDeleteModel,
    });
  };

  saveQueryCategory = () => {
    const { isAddNewCategory, isEditCategory } = this.state;
    const { queryCategoryText, queryCategory, clearCategoryText } = this.props;

    let addEditObject;
    if (isEditCategory) {
      addEditObject = {
        Id: queryCategory,
        Description: queryCategoryText,
      };
    } else if (isAddNewCategory) {
      addEditObject = {
        Id: NewEditCategoryEnum.NEW,
        Description: queryCategoryText,
      };
    }

    this.props.saveCategory(addEditObject).then(() => {
      this.props.getQueryCategoryList();
      this.getFilterData();
    });
    this.setState({
      isEditCategory: false,
      isAddNewCategory: false,
      isCategoryTextChange: false,
    });
    this.props.setNewCategory(addEditObject);
    clearCategoryText();
  };

  onDownloadClick = row => {
    const { Id, CategoryId } = row;
    this.props.downloadCustomQuery(CategoryId, Id);
  };

  onRemoveQueryClick = row => {
    const selectedQueryId = row.Id;
    this.setState({
      selectedQueryId: selectedQueryId,
      showQueryDeleteModel: !this.state.showQueryDeleteModel,
    });
    this.resetAllFields();
  };

  resetAllFields = () => {
    this.setState({
      isQueryEdit: false,
      selected: '',
      isStandardQuery: false,
    });
    this.getFilterData();
    this.props.setCustomQueryData(GenericEnum.EmptyString);
    this.props.setCustomDescriptionData(GenericEnum.EmptyString);
  };

  handleDeleteDialog = result => {
    if (result) {
      if (this.state.showQueryDeleteModel) {
        const { selectedCategoryId, selectedQueryId } = this.state;
        this.props
          .deleteQuery(selectedCategoryId, selectedQueryId)
          .then(result => {
            this.getFilterData();
          });
      } else if (this.state.showCategoryDeleteModel) {
        const { queryCategory } = this.props;
        this.props.deleteQueryCategory(queryCategory).then(result => {
          this.props.getQueryCategoryList();
          this.props.resetCategoryOnRemove();
          this.getFilterData();
        });
      }
    }
    this.setState({
      showQueryDeleteModel: false,
      showCategoryDeleteModel: false,
    });
  };

  handleSubmit = values => {
    const { QueryCategory, Query, Description } = values;
    const { selectedCategoryDescription, isQueryEdit, queryId } = this.state;
    let requestObject;
    if (isQueryEdit) {
      requestObject = {
        Id: queryId,
        Description: Description,
        Query: Query,
        CategoryName: selectedCategoryDescription,
        CategoryId: QueryCategory,
      };
      this.props.saveQuery(requestObject).then(result => {
        this.getFilterData();
      });
    } else {
      requestObject = {
        Id: NewEditQueryEnum.NEW,
        Description: Description,
        Query: Query,
        CategoryName: selectedCategoryDescription,
        CategoryId: QueryCategory,
      };
      this.props.saveQuery(requestObject).then(result => {
        this.getFilterData();
      });
      this.resetAllFields();
    }
  };

  onExecuteQueryClick = () => {
    const { queryCategory, query, description } = this.props;
    const { selectedCategoryDescription } = this.state;

    const executeQueryRequestObject = {
      Description: description,
      Query: query,
      CategoryName: selectedCategoryDescription,
      CategoryId: queryCategory,
    };

    this.props.executeCustomQuery(executeQueryRequestObject);
  };

  onResetCategoryClick = () => {
    this.setState({
      isAddNewCategory: false,
      isEditCategory: false,
    });
    this.props.clearCategoryText();
  };

  onRowClickProp = (state, rowInfo) => {
    const isSelected = rowInfo.index === this.state.selected;
    const selectedRow = {
      onClick: e => {
        if (rowInfo && rowInfo.original) {
          this.setState(
            {
              query: rowInfo.original.Query,
              descriptionEMPTY: rowInfo.original.Description,
              queryId: rowInfo.original.Id,
              selected: rowInfo.index,
              isQueryEdit: true,
              isStandardQuery:
                rowInfo.original.Source === SourceQueryEnum.STANDARD,
            },
            () => {
              this.props.setCustomDescriptionData(rowInfo.original.Description);
              this.props.setCustomQueryData(rowInfo.original.Query);
            }
          );
        }
      },
      style: {
        color: isSelected ? '#df5a17' : '',
        fontWeight: isSelected ? '600' : '500',
      },
    };
    return selectedRow;
  };

  onClearClick = () => {
    this.resetAllFields();
  };

  render() {
    const {
      customQueryCategoryListData,
      loading,
      customQueryData,
      queryCategory,
      fetchingCustomQueryCategory,
      queryCategoryText,
      gridPreferenceSubmitting,
      gridPreferenceLoading,
    } = this.props;
    const initialValues = {
      [CustomQueryEnum.QueryCategory]: this.state.selectedCategoryId,
      [CustomQueryEnum.Query]: this.state.query,
      [CustomQueryEnum.Description]: this.state.description,
    };

    return (
      <Fragment>
        <Filter title={'Custom Query'} />
        <Main {...this.getMainProps()} shouldNotUsePageWidth>
          <CustomQueryListForm
            initialValues={initialValues}
            customQueryData={customQueryData}
            columns={this.state.columns}
            reactTableRef={this.reactTable}
            setSelectedQueryCategory={this.setSelectedQueryCategory}
            addNewQueryCategory={this.addNewQueryCategory}
            editSelectedQueryCategory={this.editSelectedQueryCategory}
            removeSelectedQueryCategory={this.removeSelectedQueryCategory}
            saveQueryCategory={this.saveQueryCategory}
            customQueryCategoryListData={customQueryCategoryListData}
            loading={loading}
            isAddNewCategory={this.state.isAddNewCategory}
            showQueryDeleteModel={this.state.showQueryDeleteModel}
            handleDeleteDialog={this.handleDeleteDialog}
            isEditCategory={this.state.isEditCategory}
            queryCategory={queryCategory}
            fetchingCustomQueryCategory={fetchingCustomQueryCategory}
            queryCategoryText={queryCategoryText}
            selectedCategoryDescription={this.state.selectedCategoryDescription}
            onResetCategoryClick={this.onResetCategoryClick}
            onRowClickProp={this.onRowClickProp}
            onSubmit={this.handleSubmit}
            onClearClick={this.onClearClick}
            gridPreferenceSubmitting={gridPreferenceSubmitting}
            gridPreferenceLoading={gridPreferenceLoading}
            showCategoryDeleteModel={this.state.showCategoryDeleteModel}
            isStandardQuery={this.state.isStandardQuery}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { customQueries } = state.UtilitiesState;
  const {
    customQueryCategoryListData,
    loading,
    customQueryData,
    categoryDeleteSuccess,
    categorySaveSuccess,
    customQueryCategoryListError,
    customQueryDataError,
    newCategory,
    categorySaveError,
    categoryEditError,
    categoryDeleteError,
    fetchingCustomQueryCategory,
    customQueryDownloadError,
    customQueryDeleteError,
    customQueryDeleteSuccess,
    customQueryCategoryDeleteSuccess,
    customQuerySaveSuccess,
    querySaveError,
    queryExecuteError,
  } = customQueries;
  const selector = formValueSelector(CUSTOM_QUERY_FORM_NAME);
  ownProps.setPageLevelDirty(getIsDirty(CUSTOM_QUERY_FORM_NAME)(state));

  const { gridPreference } = state.CommonState;
  return {
    initialValues: {
      [CustomQueryEnum.QueryCategory]: 1,
    },
    customQueryCategoryListData: customQueryCategoryListData,
    loading: loading,
    customQueryData: customQueryData,
    queryCategoryText: selector(state, CustomQueryEnum.QueryCategoryText),
    queryCategory: selector(state, CustomQueryEnum.QueryCategory),
    description: selector(state, CustomQueryEnum.Description),
    query: selector(state, CustomQueryEnum.Query),
    newCategory: newCategory,
    categoryDeleteSuccess: categoryDeleteSuccess,
    categorySaveSuccess: categorySaveSuccess,
    customQueryCategoryListError: customQueryCategoryListError,
    customQueryDataError: customQueryDataError,
    categorySaveError: categorySaveError,
    categoryEditError: categoryEditError,
    categoryDeleteError: categoryDeleteError,
    fetchingCustomQueryCategory: fetchingCustomQueryCategory,
    customQueryDownloadError: customQueryDownloadError,
    customQueryDeleteError: customQueryDeleteError,
    customQueryDeleteSuccess: customQueryDeleteSuccess,
    customQueryCategoryDeleteSuccess: customQueryCategoryDeleteSuccess,
    customQuerySaveSuccess: customQuerySaveSuccess,
    gridPreferenceLoading: gridPreference.loading,
    gridPreferenceSubmitting: gridPreference.isSubmitting,
    querySaveError: querySaveError,
    queryExecuteError: queryExecuteError,
  };
};
const mapDispatchToProps = {
  ...actions,
  submitForm,
};
export const CustomQuery = connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomQueryListFormContainer);



// WEBPACK FOOTER //
// ./src/pages/utilities/customqueries/containers/customQueryList/CustomQueryListFormContainer.js